import { render, staticRenderFns } from "./fields-form.vue?vue&type=template&id=23f8b908&"
import script from "./fields-form.vue?vue&type=script&lang=js&"
export * from "./fields-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports